<template>

	<!-- menu with submenu -->
	<div v-if="menu.children" class="menu-item has-sub"
		v-bind:class="{ 'active': subIsActive(menu.path), 'expand': this.stat =='expand', 'd-none': this.stat =='hide' }">
		<a href="#" class="menu-link" v-on:click.prevent.stop="expand($event)"
			@mouseover="mouseOver(menu.children, $event)" @mouseleave="hideFloatSubmenu">
			<div class="menu-icon" v-if="menu.icon"><i v-bind:class="menu.icon"></i></div>
			<div v-if="menu.img" class="menu-icon-img"><img v-bind:src="menu.img" alt="" /></div>
			<div class="menu-text">
				<p class="menuFont" :class="{menuFontactive:menu.icon?true:false}">{{ menu.title }}</p>
				<span v-if="menu.label" class="menu-label">{{ menu.label }}</span>
				<i v-if="menu.highlight" class="fa fa-paper-plane text-theme"></i>
			</div>
			<div v-if="menu.badge" class="menu-badge">{{ menu.badge }}</div>
			<div v-else class="menu-caret"></div>
		</a>
		<div class="menu-submenu" v-bind:class="{ 'd-block': this.stat == 'expand', 'd-none': this.stat == 'collapse' }"
			v-bind:style="{ marginTop: (appOptions.appSidebarMinified) ? - (scrollTop + 40) + 'px' : '' }">
			<template v-for="submenu in menu.children">
				<sidebar-nav-list v-bind:menu="submenu" v-bind:key="submenu.path" ref="sidebarNavList"
					v-on:calc-float-submenu="handleCalcFloatSubmenu" v-on:collapse-other="handleCollapseOther(submenu)">
				</sidebar-nav-list>
			</template>
		</div>
	</div>

	<!-- menu without submenu -->
	<router-link v-else v-bind:to="menu.path" class="menu-item"
		v-bind:class="{'homemar': subIsHome(menu.path),'d-none': this.stat =='hide' }" active-class="activebg" 
		v-on:click.native="collapseOther()">
		<a class="menu-link">
			<div class="menu-icon" v-if="menu.icon"><i v-bind:class="menu.icon"></i></div>
			<div v-if="menu.img" class="menu-icon-img"><img v-bind:src="menu.img" alt="" /></div>
			<div class="menu-text">
				<p class="menuFont">{{ menu.title }}</p>
				<span v-if="menu.label" class="menu-label">{{ menu.label }}</span>
				<i v-if="menu.highlight" class="fa fa-paper-plane text-theme"></i>
			</div>
			<div v-if="menu.badge" class="menu-badge">{{ menu.badge }}</div>
		</a>
	</router-link>
</template>

<style scoped lang="less">
	/* .app-sidebar .menu .menu-item.active  {
		background-color: #ECF5FF !important;
		
	}*/
	
	
	.app-sidebar .menu .menu-item.active {
		background: #EEF5F9;
	}

	.menu-icon {
		background: -webkit-linear-gradient(#2ebf91, #8360c3);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		font-size: 1rem !important;
	}


	.app-sidebar .menu .menu-item.active>.menu-item {
		background: #EEF5F9;
	}

	.app-sidebar .menu .menu-item.active>.menu-link {
		background: #EEF5F9;
	}

	.app-sidebar .menu .menu-item.active>.menu-link p {
		/* background-color: #ECF5FF !important; */
		color: #2e61bf !important;
		font-weight: 700;
		font-size: 1rem;
	}

	.menu-text p {
		font-size: 0.8rem;
	}

	.app-sidebar .menu .menu-item .menu-submenu {
		padding: 0;
	}



	.homemar {
		margin-top: 0.7rem;
	}

	.homemar p {
		font-size: 1rem;
	}


	.menu-link:hover {
		background: linear-gradient(to left, #7c8ce4, #2196f3) !important;
		border-left: 4px solid #7b4397;
		color: #fff !important;

		// .menu-link p{
		// 	color: #fff !important;
		// }
		.menu-icon {
			color: #fff !important;
		}
	}

	.app-sidebar .menu .menu-item .menu-submenu .menu-item .menu-link {
		padding: 0.6rem 3.5rem !important;
	}



	// .menu-item .menuFont:hover{

	// }


	.menu-item {
		/* background-color: #fff; */
		padding: 0 0 0 0;
		box-sizing: border-box;
	}

	// .menu-item {
	// 	.menu-item {
	// 		.menu-link {
	// 			padding-left: 1.5rem !important;
	// 		}
	// 	}
	// }


	.menu-link {
		padding: 12px 20px !important;
	}

	/* .menuFontactive{
		background-color: #ccc;
	} */

	.menu-icon {
		color: #000;
	}

	.activebg {
		font-size: 18px !important;
		background: #EEF5F9;
	}

	.expand .menu-icon {
		color: #2e61bf !important;
	}

	/* .expand .menuFont:first-child{
		color: #20A0CE;
	} */

	.activebg .menu-icon {
		color: #2e61bf;
	}


	.activebg p {
		color: #2e61bf;
		font-weight: 700;
	}

	.menu-caret {
		color: #000 !important;
	}

	.menuFont:hover {
		color: #fff;
	}

	.menuFont {
		color: #000;
		margin: 0;
	}
</style>

<script>
	import SidebarNavList from './SidebarNavList.vue'
	import AppOptions from '../../config/AppOptions.vue'

	export default {
		name: 'SidebarNavList',
		props: ['menu', 'scrollTop'],
		components: {
			SidebarNavList
		},
		created() {
			// // console.log(this.menu)
			// if (this.menu.path == "/home") {
			// 	// console.log(1111)
			// }
			
			
			
		},
		mounted() {
			// console.log(this.menu)
		},
		
		data() {
			return {
				stat: '',
				appOptions: AppOptions
			}
		},
		methods: {
			validate(str) {
				var reg = new RegExp("^[0-9]{6}$");
				if (!reg.test(str)) {
					return false;
				} else {
					return true
				}
			},
			mouseOver: function(data, event) {
				if (this.appOptions.appSidebarMinified) {
					var offset = event.target.offsetParent.getBoundingClientRect();
					this.$emit('show-float-submenu', data, offset);
				}
			},
			hideFloatSubmenu: function() {
				if (this.appOptions.appSidebarMinified) {
					this.$emit('hide-float-submenu');
				}
			},
			expand: function() {
				if (this.stat == '') {
					this.stat = (this.subIsActive(this.menu.path)) ? 'collapse' : 'expand';
				} else {
					this.stat = (this.stat == 'expand') ? 'collapse' : 'expand'
				}
				this.$emit('collapse-other', this.menu);

				if (this.appOptions.appSidebarMinified) {
					this.$emit('calc-float-submenu');
				}
			},
			handleCalcFloatSubmenu: function() {
				if (this.appOptions.appSidebarMinified) {
					this.$emit('calc-float-submenu');
				}
			},
			collapse: function(menu) {
				if (this.menu != menu) {
					this.stat = 'collapse'
				}
			},
			hide: function() {
				this.stat = 'hide'
			},
			show: function() {
				this.stat = '';
			},
			searchExpand: function() {
				this.stat = 'expand'
				
			},
			collapseOther: function() {
				this.$emit('collapse-other', this.menu)
			},
			handleCollapseOther: function(menu) {
				for (var i = 0; i < this.menu.children.length; i++) {
					this.$refs.sidebarNavList[i].collapse(menu);
				}
			},
			subIsActive(path) {
				const paths = Array.isArray(path) ? path : [path]
				return paths.some(path => {
					return this.$route.path.indexOf(path) === 0
				})
			},
			subIsHome(path) {
				if (path == "/home") {
					return true
				} else {
					return false
				}
			}
		}
	}
</script>
